module.exports = __webpack_public_path__ + "img/reject.ac814cc7.svg";